import './BannerEditor.less';
import React, {useState, useEffect} from 'react';
import __ from "../../i18n";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../bootstrap/api/Request";
import Toasts, {TOAST_SUCCESS} from "../../../bootstrap/scomponents/toasts/Toasts";
import BannerCreateParcel from "../../api/endpoints/banner/BannerCreateParcel";
import BannerUpdateParcel from "../../api/endpoints/banner/BannerUpdateParcel";
import places from "../../model-constants/banner/places";


export default function BannerEditor({recordId = null, defaultValues = {}, onDone, onCancel}) {

    const isCreation = recordId === null;

    const fieldsConfig = {
        image_id: {
            name: __('Image'),
            type: 'image',
            rules: {
                required: true,
            }
        },
        place: {
            name: __('Place'),
            type: 'singleSelect',
            data: {
                options: places
            },
            rules: {
                required: true
            }
        },
        caption: {
            name: __('Caption'),
            type: 'text',
            rules: {
                required: true
            },
            options: {
                appearance: 'box'
            }
        },
        linked_url: {
            name: __('Linked URL'),
            type: 'text',
            rules: {
                required: false,
                match: 'url'
            },
            options: {
                appearance: 'box'
            }
        },
        sort_order: {
            name: __('Sort order'),
            type: 'number',
            rules: {
                required: true,
            },
            options: {
                appearance: 'box'
            }
        },
    };

    const layoutConfig = [
        'image_id',
        'place',
        'caption',
        'linked_url',
        'sort_order',
    ];

    const submit = (values, onSuccess, onError) => {

        if (isCreation) {
            Request.add(new BannerCreateParcel(values))
                .then((data) => {
                    Toasts.add(TOAST_SUCCESS, __('Your banner was added successfully'));
                    onSuccess();
                    onDone(data);
                })
                .catch(error => {
                    onError(error.getMessage());
                });

            return;
        }

        Request.add(new BannerUpdateParcel(recordId, values))
            .then((data) => {
                Toasts.add(TOAST_SUCCESS, __('Your changes have been saved successfully'));
                onSuccess();
                onDone(data);
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    const cancel = () => {
        onCancel();
    };

    return <div className="banner-editor">
        <div className="sub-title">{__('Banner information')}</div>
        <CustomForm
            fieldsConfig={fieldsConfig}
            layoutConfig={layoutConfig}
            submitChanges={submit}
            cancel={cancel}
            submitText={isCreation ? __('Add banner') : __('Save changes')}
            defaultValues={defaultValues}
        />
    </div>;
}
